import { render, staticRenderFns } from "./BaseLink.vue?vue&type=template&id=f3307914&"
import script from "./BaseLink.vue?vue&type=script&lang=ts&"
export * from "./BaseLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports